export default __webpack_public_path__ + "static/media/404.671c9aa2.jpg";